const PRODUCT_FRAGMENT = `
id
allergens
calorieData {
  caloriesPerServing
}
defaultVariantId
description
images {
  original
  standard
  thumb
}
inStock
limit
dietaryRequirements
modifierGroups {
  id
  name
  maximum
  minimum
  modifiers {
    id
    allergens
    image {
      original
      standard
      thumb
    }
    inStock
    name
    price {
      base
      discounted
      reduction
    }
    restrictions {
      alcoholic
    }
  }
}
name
options {
  name
  values
}
pricing {
  lowestVariant {
    base
    discounted
    reduction
  }
  maximum { 
    base 
    discounted
    reduction
  }
  minimum {
    base
    discounted
    reduction
  }  
}
promotion {
  amount
  discountType
}
quickAddAllowed
seoDescription
slug
restrictions {
  alcoholic
}
variants {
  allergens
  id
  inStock
  name
  limit
  pricing {
    absolute {
      base
      discounted
      reduction
    }
    relative {
      base
      discounted
      reduction
    }
  }
  restrictions {
    alcoholic
  }
  options {
    name
    value
  }
}
`

export { PRODUCT_FRAGMENT }
